// import external modules
import React from "react";
// import { useSelector } from 'react-redux';
import Navbar from "../components/NavbarNew";
import Footer from "../components/FooterNew";
import { connect } from "react-redux";
import NavbarNew from "../components/NavbarNew";
import FooterNew from "../components/FooterNew";
// import internal(own) modules
// import Spinner from '../../';

const NavbarOnlyLayout = ({ children, values, ...rest }) => {
  // const { isLoading } = useSelector((state) => state.layout);

  return (
    <div className="main-wrapper">
      {/* {isLoading && (
        <div className="data-loading">
          <Spinner />
        </div>
      )} */}
      <NavbarNew />
      <main
        className={`${values && values.loginFlag ? "" : "login-main-page"}`}>
        {children}
      </main>
      <FooterNew />
    </div>
  );
};
const mapStateToProps = (state) => {
  // console.log("state", state);
  return {
    values: state.auth.login,
  };
};
export default connect(mapStateToProps)(NavbarOnlyLayout);
